import { InputAdornment, TextField } from "@mui/material";
import { useUserInfo } from "../utils/security";
import { isEmpty } from "lodash";

const CurrencyField = ({ currencyCode, perUnit, digits = 2, value, onChange, ...props }) => {
    const { userInfo } = useUserInfo();
    const currency = userInfo?.currencies[currencyCode] ||
        userInfo?.defaultCurrency || {
            symbol: "¤",
            decimalDigits: 2,
            symbolPosition: "left",
        };

    let startAdornment = "";
    let endAdornment = "";

    if (currency.symbolPosition === "left") {
        startAdornment = currency.symbol;
    } else {
        endAdornment = currency.symbol;
    }
    if (!isEmpty(perUnit)) {
        endAdornment += `/${perUnit}`;
    }

    let inputProps = {};
    if (!isEmpty(startAdornment)) {
        inputProps.startAdornment = (
            <InputAdornment position="start">{startAdornment}</InputAdornment>
        );
    }
    if (!isEmpty(endAdornment)) {
        inputProps.endAdornment = <InputAdornment position="end">{endAdornment}</InputAdornment>;
    }

    return (
        <TextField
            {...props}
            value={value || ""}
            onChange={onChange}
            inputProps={{ style: { textAlign: "right" } }}
            InputProps={inputProps}
        />
    );
};

export default CurrencyField;
